// Connector URL customers paste into Claude (or another MCP client) together with an
// AI assistant API token. Override per environment with VUE_APP_MCP_CONNECTOR_URL.
export const MCP_CONNECTOR_URL = process.env.VUE_APP_MCP_CONNECTOR_URL || 'https://api2.corporategift.com/mcp/customer'
